import axios from 'axios';

const api = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:8080/rest'
      : `${window.location.origin}${window.location.pathname}rest`,
});

export default api;
